












import { computed, defineComponent, ref } from "@vue/composition-api";
import { Group, InputGroupCreate } from "@scrile/api-provider/dist/api/GroupsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import { FormField } from "@/types";
import BasePromptConfirmation from "@/components/BasePromptConfirmation";

export default defineComponent({
  name: "CreateGroupModal",
  components: { BasePromptConfirmation },
  props: {
    show: { type: Boolean, required: true },
    group: { type: Object as () => Group, default: null },
  },
  setup(props, { emit }) {
    const { authUserStrict } = useAuthUser();

    const loading = ref(false);

    const inputProps = computed<Partial<FormField>>(() => {
      return {
        value: props.group ? props.group.name : "",
        placeholder: $t("My new list"),
        autofocus: true,
        rules: ["required"],
        validationMode: "aggressiveNotBlur",
      };
    });

    const title = computed(() => {
      return props.group ? "Rename list" : "Create new list";
    });

    const createGroup = async (groupName: string, clearInput: Function) => {
      if (loading.value) return;
      const data: InputGroupCreate = {
        ownerId: authUserStrict.value.id,
        name: groupName,
        memberIds: [],
      };
      try {
        loading.value = true;
        const createdGroup = await providers.GroupsProvider.create({ data });
        clearInput();
        emit("create", createdGroup);
        emit("close");
      } finally {
        loading.value = false;
      }
    };

    const renameGroup = async (groupName: string) => {
      if (loading.value) return;
      try {
        loading.value = true;
        const response = await providers.GroupsProvider.update({
          data: {
            id: (props.group as Group).id,
            name: groupName,
          },
        });
        emit("rename", response);
        emit("close");
      } finally {
        loading.value = false;
      }
    };

    const submit = (groupName: string, clearInput: Function) => {
      return props.group ? renameGroup(groupName) : createGroup(groupName, clearInput);
    };

    return {
      loading,
      inputProps,
      title,
      submit,
    };
  },
});
